import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setUnauthorizedHandler, TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export const ROLE_LABELS = { admin: "Administrador", equipo: "Equipo", revisor: "Revisor" };
export const canWrite = (user) => user?.role === "admin" || user?.role === "equipo";
export const isAdmin = (user) => user?.role === "admin";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const clearSession = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
  }, []);

  useEffect(() => {
    setUnauthorizedHandler(clearSession);
    if (!localStorage.getItem(TOKEN_KEY)) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(clearSession)
      .finally(() => setReady(true));
  }, [clearSession]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // session already invalid
    }
    clearSession();
  };

  return <AuthContext.Provider value={{ user, ready, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
